export default {
  arraste_arquivos: 'Arraste arquivos aqui',
  ou: 'ou',
  escolha_arquivo: 'Escolha um arquivo',
  tamanho_maximo_permitido: 'O anexo deve ter o tamanho máximo de 2 MB',
};
